import React from 'react'
import useEmblaCarousel from 'embla-carousel-react'

import { DotButton, useDotButton } from './EmblaCarouselDotButton'
import {
  PrevButton,
  NextButton,
  usePrevNextButtons
} from './EmblaCarouselArrowButtons'

import './embla.css'
import { S3_ENDPOINT, trialClassCheckoutRoute } from '../../utils'
import { Link, useNavigate } from '@reach/router'

const OPTIONS = { align: 'start' }

const ClassTypesCarousel = ({ class_types, hideButton, imageOverrides, descriptionOverrides, branch_id }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel(OPTIONS);
  const navigate = useNavigate();

  const { selectedIndex, scrollSnaps, onDotButtonClick } =
    useDotButton(emblaApi)

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick
  } = usePrevNextButtons(emblaApi)

  return(
    <>
      <section className="embla">
        <div className="embla__viewport" ref={emblaRef}>
          <div className="embla__container">
            {class_types?.filter(type => type.show_home)
              .sort((a, b) => a.order - b.order)
              .map((type) => {
                const src = imageOverrides?.[type.class_type_id]
                  || (type.file !== null
                    ? `${S3_ENDPOINT}/${type.file.name}.${type.file.type}`
                    : "");

                return (
                  <div className="embla__slide" key={type.class_type_id}>
                    <Link
                      to={`/class_type/${type.class_type_id}`}
                      className="embla__slide-link"
                    >
                      <div className="embla__slide__number" style={{
                        backgroundColor: '#FAFAFA'
                      }}>
                        <p className='embla__type-name'>{type.name}</p>
                        <img alt={type.name} className='embla__type-image' src={src}/>
                        <p className='embla__type-description gothic-font'>
                          {descriptionOverrides?.[type.class_type_id] ?? type.description}
                        </p>
                      </div>
                    </Link>
                  </div>
                )
            })}
          </div>
        </div>

        <div className="embla__controls">
          <div className="embla__buttons">
            <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
            <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />
          </div>

          <div className="embla__dots">
            {scrollSnaps.map((_, index) => (
              <DotButton
                key={index}
                onClick={() => onDotButtonClick(index)}
                className={'embla__dot'.concat(
                  index === selectedIndex ? ' embla__dot--selected' : ''
                )}
              />
            ))}
          </div>
        </div>

       {!hideButton && <div className='row justify-content-center mx-auto class-types-cta__container'>
          <button 
            type="button"
            className={`btn bold px-4 ${branch_id === 2 ? "bg-gradient-landing--tijuana text-dark" : "bg-gradient-landing text-white"}`}
            style={{ borderRadius: '40px', height: '50px', width: 'max-content'}}
            onClick={() => navigate(trialClassCheckoutRoute)}
          >
            COMIENZA YA
            <i className="fas fa-arrow-right ms-2"/>
          </button>
        </div>}
      </section>
    </>
  )
}



export default ClassTypesCarousel;

